import { render, staticRenderFns } from "./index.vue?vue&type=template&id=559a6c7e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=559a6c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a6c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559a6c7e')) {
      api.createRecord('559a6c7e', component.options)
    } else {
      api.reload('559a6c7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=559a6c7e&scoped=true&", function () {
      api.rerender('559a6c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/videoChannel/draftList/index.vue"
export default component.exports